import { useState, useEffect, useRef } from "react";
import { LoadingOverlay } from "../Components/Loading/LoadingOverlay";
import { CircleAnalyticsDisplay } from "../Components/CircleGraphs/CircleAnalyticsDisplay";
import { BarAnalyticsDisplay } from "../Components/BarGraph/BarAnalyticsDisplay";
import { TitleAndMenu } from "../Components/Menu/TitleAndMenu";
import {
    Container,
    AnalyticsContainer,
    AnalyticsAndTopContainer,
} from "./DashboardStyle";
import { StaticMetricsContainer } from "../Components/StaticMetrics/StaticMetricsContainer";
import { useAppDispatch, useAppSelector } from "../Hooks/Hooks";
import {
    setMassagedTimeData,
    setStaticData,
    setTimeData,
    setUserData,
} from "../Redux/Data/DataSlice";
import {
    selectAnalyticUsage,
    selectCommandUsage,
    selectLeaderboard,
} from "../Redux/Menu/MenuSlice";
import { MobileMenu } from "../Components/Menu/MobileMenu";
import { MobileBarAnalyticsDisplay } from "../Components/MobileBarGraph/MobileBarAnalyticsDisplay";
import { Leaderboard } from "../Components/Leaderboard/Leaderboard";
import { setWindowSize } from "../Redux/Theme/ThemeSlice";

export const Dashboard: React.FC = () => {
    const [loading, setIsLoading] = useState<boolean>();
    const showBarGraph = useAppSelector(selectCommandUsage);
    const showAnalyticMetrics = useAppSelector(selectAnalyticUsage);
    const showLeaderboard = useAppSelector(selectLeaderboard);

    const dispatch = useAppDispatch();

    const screenRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                await fetch(
                    "https://liquibot-api.herokuapp.com/get_timestamped_data_two"
                )
                    .then((response) => response.json())
                    .then((data) => {
                        dispatch(setTimeData(data));
                        dispatch(setMassagedTimeData(data));
                    });
            } catch (error) {
                console.error("Error fetching time data: ", error);
            }
            try {
                await fetch("https://liquibot-api.herokuapp.com/get_data")
                    .then((response) => response.json())
                    .then((data) => {
                        dispatch(setStaticData(data));
                    });
            } catch (error) {
                console.error("Error fetching static metrics: ", error);
            }
            try {
                await fetch("https://liquibot-api.herokuapp.com/get_user_data")
                    .then((response) => response.json())
                    .then((data) => {
                        dispatch(setUserData(data));
                    });
            } catch (error) {
                console.error("Error fetching users: ", error);
            }
            setIsLoading(false);
        };
        fetchData();
    }, [dispatch]);

    useEffect(() => {
        screenRef.current
            ? dispatch(setWindowSize(screenRef.current.offsetWidth))
            : dispatch(setWindowSize(0));
    }, [screenRef, dispatch]);

    return (
        <>
            {loading ? (
                <LoadingOverlay />
            ) : (
                <Container ref={screenRef}>
                    <MobileMenu />
                    <TitleAndMenu />
                    <AnalyticsAndTopContainer>
                        <AnalyticsContainer>
                            {showBarGraph && (
                                <>
                                    <BarAnalyticsDisplay />
                                    <MobileBarAnalyticsDisplay />
                                </>
                            )}
                            {showAnalyticMetrics && (
                                <>
                                    <StaticMetricsContainer />
                                    <CircleAnalyticsDisplay />
                                </>
                            )}
                            {showLeaderboard && (
                                <>
                                    <Leaderboard />
                                </>
                            )}
                        </AnalyticsContainer>
                    </AnalyticsAndTopContainer>
                </Container>
            )}
        </>
    );
};
